module.exports = __webpack_public_path__ + "static/media/AP4.6a1b4b47.webp";